import { appConfig } from "@/constants";
import { EnvironmentNames } from "@/types";
import { http, createPublicClient } from "viem";
import { mainnet, sepolia } from "viem/chains";

/**
 * Get the appropriate chain based on environment
 */
function getChain() {
  return appConfig.ENVIRONMENT === EnvironmentNames.PRODUCTION
    ? mainnet
    : sepolia;
}

/**
 * Get Alchemy RPC URL for the current environment
 */
function getAlchemyRpcUrl(): string {
  if (!appConfig.ALCHEMY_API_KEY) {
    throw new Error("ALCHEMY_API_KEY is not set");
  }

  const network =
    appConfig.ENVIRONMENT === EnvironmentNames.PRODUCTION
      ? "eth-mainnet"
      : "eth-sepolia";

  return `https://${network}.g.alchemy.com/v2/${appConfig.ALCHEMY_API_KEY}`;
}

/**
 * Viem public client for Ethereum mainnet/sepolia (depending on environment)
 * Uses Alchemy as the RPC provider
 */
export const ethereumClient = createPublicClient({
  chain: getChain(),
  transport: http(getAlchemyRpcUrl()),
});

/**
 * Get the Ethereum chain for the current environment
 */
export { getChain as getEthereumChain };
